// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"jr","promotionalTile":"js","promotionalTileThumb":"jt","promotionalTileHeader":"ju","promotionalTileCaption":"jv"};